import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: 'ncr',
    children: [
      {
        path: 'lesson',
        redirect: (to) => ({
          name: 'ncr-lesson',
          params: { accountUuid: to.query.uuid?.toString() },
          query: {},
        }),
      },
      {
        name: 'ncr-lesson',
        path: 'lesson/:accountUuid',
        props: true,
        component: () => import('../LessonIndex.vue'),
      },
    ],
  },
];
